<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import TaxProfileForm from "./components/TaxProfileForm.vue"

defineProps<{
  tax_profile: {
    id: number
    company_id: number | ""
    name: string
    active: boolean
    default: boolean
    credit_icms: boolean
    credit_pis_cofins: boolean
    ipi_included_in_cost: boolean
    estimated_sales_tax_percent: string
  }
  companies: Array<{ id: number; name: string }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <TaxProfileForm
      mode="edit"
      title="Perfis Fiscais"
      subtitle="Atualize parametros fiscais do perfil selecionado."
      :tax_profile="tax_profile"
      :companies="companies"
      :errors="errors"
    />
  </AppShell>
</template>
